import React, { forwardRef, useEffect, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment/moment";
import { CUSTOM } from "../../constants/OptionsConstants";
import { CURRENT_MONTH, CUSTOM_DATE, defaultSelectOptions, LAST_12_MONTHS, LAST_28_DAYS, LAST_30_DAYS, LAST_3_MONTHS, LAST_6_MONTHS, LAST_7_DAYS, LAST_90_DAYS, LAST_CALENDAR_YEAR, LAST_MONTH, LAST_YEAR } from "../../constants/DatePickerSelectOptions";
import { useSearchParams } from "react-router-dom";



const customStyles = {
  container: (provided) => ({
    ...provided,
    padding: 0,
    "&:focus-visible": {
      outline: "none",
    },
  }),
  control: (provided) => ({
    ...provided,
    "&:hover": {
      borderColor: "none",
    },

    border: "none",
    outline: "none",
    minHeight: "unset",
    cursor: "pointer",
    minWidth: "60px",
    overflow: "hidden",
    boxShadow: "none",

  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 6px"
  }),

  singleValue: (provided) => ({
    ...provided,
    margin: "0 ",
    fontSize: "12px",
    fontWeight: "600",
    color: lightThemeColors.primaryColor,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,

    color: lightThemeColors.primaryColor,
    padding: "0 6px 0 0",
    width: "20px",
    "&:hover": {
      color: lightThemeColors.primaryColor,
    },

  }),

  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  input: (provided) => ({
    ...provided,
    padding: "0",
  }),
  option: (provided) => ({
    ...provided,
    padding: "4px 6px",
    fontSize: "12px"
  }),
};

const CustomInputDate = ({ startDate, endDate, handleSetDate, disableCustomDate }) => {
  let sDate = "";
  let eDate = "";

  if (startDate) {
    sDate = moment(startDate).format("DD MMM");
  }
  if (endDate) {
    eDate = moment(endDate).format("DD MMM");
  }

  const ExampleCustomInput = forwardRef(({ value, onClick, disableCustomDate }, ref) => (
    <CustomDateButton
      className="example-custom-input"
      onClick={disableCustomDate ? () => { return } : onClick}
      ref={ref}

    >
      {`${sDate} - ${eDate}`}
    </CustomDateButton>
  ));

  return (
    <ReactDatePicker
      selected={startDate}
      onChange={handleSetDate}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      customInput={<ExampleCustomInput disableCustomDate={disableCustomDate} />}
      popperPlacement="bottom-start" // Adjust this as needed

    />
  );
};

const DatePickerWithOptions = ({
  selectMenuOptions = defaultSelectOptions,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  disableCustomDate,
  months, setMonths,
  handleOptionSelect
}) => {

  const [searchParams, setSearchParams] = useSearchParams();

  const handleSetDate = (dates) => {
    const [start, end] = dates;

    setStartDate(start);
    setEndDate(end);

    setMonths({
      value: CUSTOM_DATE,
      label: CUSTOM,
    });

    setSearchParams((prev) => {
      prev.set("date_type", CUSTOM_DATE);
      prev.set("start_date", moment(start).toISOString());
      prev.set("end_date", moment(end).toISOString());
      return prev;
    });
  };

  return (
    <Container>
      <Select
        styles={customStyles}
        value={months}
        options={selectMenuOptions}
        onChange={(e) => handleOptionSelect(e)}
        isSearchable={false}
      />

      <CustomInputDate
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleSetDate={handleSetDate}
        disableCustomDate={disableCustomDate}
      />
    </Container>
  );
};

export default DatePickerWithOptions;
const Container = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${lightThemeColors.primaryColor};
  border-radius: 5px;
  position: relative;
  max-height: 30px;
  width: fit-content;
  position:relative;
`;
const CustomDateButton = styled.button`
  border: none;
  min-width: 60px;
  padding: 2px 6px;
  border-radius: 5px;
  background: none;
  cursor: pointer;
  border-left: 1px solid ${lightThemeColors.primaryColor};
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: ${lightThemeColors.primaryColor};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
  &:active: {
    border: 1px soldi red;
  }
`;
